import React from "react";
import Chatnav from "../components/chat/Chatnav"
import style from "./Chat.module.css";
import Chats from "../components/chat/Chats";
import { Outlet } from "react-router";
const Chat =()=>{
    return(
        <div className={style.chatpage}>
            <div className={style.rcircle}></div>
                <Chatnav/>
                <div className={style.chatcontainer}>
                    <Outlet/>
                    <Chats/>
                </div>
            <div className={style.lcircle}></div>
        </div>
    )
}
export default Chat
